import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'

import Header from './components/layout/Header'
import Footer from './components/layout/Footer'

import ScrollTop from './components/ScrollTop'

// PAGES
import Home from './pages/Home'
import Gallery from './pages/Gallery'
import DetailProduct from './pages/DetailProduct'
import CompareProduct from './pages/CompareProduct'

function App() {
  return (
    <div>
      <Router>
        <ScrollTop />
        <Header />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/gallery/:type">
            <Gallery />
          </Route>
          <Route path="/motor/:id">
            <DetailProduct type='bike' />
          </Route>
          <Route path="/mobil/:id">
            <DetailProduct type='car' />
          </Route>
          <Route path="/comparasion">
            <CompareProduct />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
